import { AsyncPipe, DecimalPipe } from '@angular/common';
import { AfterContentInit, Component, ElementRef, HostListener, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Image, StoreType } from 'src/app/models';
import { buttonIcons } from 'src/app/modules/icon.module';
import { BasketQuery } from 'src/app/services/basket/basket.query';
import { ContentService, sections } from 'src/app/services/content/content.service';
import { ShippingDialogService } from 'src/app/services/dialog/shipping-dialog.service';
import { MobileService } from 'src/app/services/mobile.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { environment } from 'src/environments/environment';
import { LayoutService } from 'src/app/services/device-detector/layout.service';
import { IconButtonComponent } from '../../components';
import { MemberBarComponent } from '../../components/auth';
import { ContentImagePipe } from '../../pipes/cms-image.pipe';
import { DisplayCurrencyPipe } from '../../pipes/display-currency.pipe';
import { ContentSection } from '../content-section';

@Component({
  selector: 'app-meny-header',
  templateUrl: './meny-header.component.html',
  styleUrls: ['./meny-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MemberBarComponent,
    IconButtonComponent,
    ContentImagePipe,
    RouterLink,
    MatIconModule,
    MatBadgeModule,
    AsyncPipe,
    DecimalPipe,
    DisplayCurrencyPipe,
  ],
})
export class MenyHeaderComponent extends ContentSection implements OnInit, AfterContentInit {
  private basketQuery = inject(BasketQuery);
  private shippingDialogService = inject(ShippingDialogService);
  private mobileService = inject(MobileService);
  private layoutService = inject(LayoutService);
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);

  contentUrl = environment.cmsOrigin;
  menuIcon: string;
  basketIcon = buttonIcons.basket;
  locale = environment.i18n.language;
  currency = environment.i18n.currency;
  customerServiceUrl = `/${environment.urls.content.customer_service}`;

  basketUrl = environment.urls.basket;

  findShopUrl: string;
  findShopUrlSameSite: boolean;
  menuLabel: string;
  basketLabel: string;
  storeLogo: Image;
  store: string;
  isEventStore: boolean;

  enableMembers: boolean;
  @Input() showBasket = true;
  @Input() showShipping = true;

  price$: Observable<number>;
  count$: Observable<number>;
  isLoading$: Observable<boolean>;
  isMobile = false;

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, sections.header);

    this.enableMembers = this.contentService.getMerchant().enableMembers;

    this.store = this.contentService.getStoreAddress();

    this.menuLabel = this.content.get('deliveryPickup');
    this.basketLabel = this.content.get('totalPrice');
    this.storeLogo = { src: this.content.get('headerImage'), alt: this.contentService.getTitle() };

    this.checkScreenSize();

    const type = this.contentService.getMerchant().type;
    if (type === StoreType.MENY) this.findShopUrl = 'https://meny.dk/find-butik';
    if (type === StoreType.MIN_KOBMAND) {
      this.findShopUrl = `/${environment.urls.content.contact_us}`;
      this.findShopUrlSameSite = true;
    }

    this.isEventStore = this.contentService.isEventStore;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    switch (true) {
      case this.layoutService.isMobile:
      case this.layoutService.isTablet:
      case this.layoutService.isSmallDesktop:
        this.menuIcon = buttonIcons.menu;
        this.isMobile = true;
        break;
      default:
        this.menuIcon = buttonIcons.shipping;
        this.isMobile = false;
    }
  }

  ngOnInit() {
    this.price$ = this.basketQuery.selectTotal$;
    this.count$ = this.basketQuery.selectProductLines$.pipe(
      map((productLines) => {
        let count = 0;
        productLines.forEach((line) => (count += line.quantity));
        return count;
      }),
    );
    this.isLoading$ = this.basketQuery.selectLoading();
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }

  openMenu() {
    if (this.isMobile) {
      this.mobileService.setOverlay(true);

      return;
    }

    this.shippingDialogService.openShippingDialog();
  }
}
